import React from "react"
import Main from "./pages/Main"
import Login from "./pages/auth/Login"
import Register from "./pages/auth/Register"
import ForgotPassword from "./pages/auth/ForgotPassword"
import Error404Modern from "./pages/error/404-modern"
import AuthRoute from "./route/AuthRoute"
import Layout from "./layout/Index"

import { Routes, Route } from "react-router-dom"

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />

      {/* Auth Route */}
      <Route path="auth-login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="register" element={<Register />} />

      {/* Private Route */}
      <Route element={<AuthRoute />}>
        <Route path="dashboard/*" element={<Layout />} />
      </Route>
      
      
      {/* Non Existent Routes */}
      <Route path="*" element={<Error404Modern />} />
    </Routes>
  )
}

export default App














// import React from "react";
// import { Routes, Route } from "react-router-dom";
// // import { RedirectAs404 } from "./utils/Utils";
// // import PrivateRoute from "./route/PrivateRoute";

// // import Layout from "./layout/Index";

// // import Error404Classic from "./pages/error/404-classic";
// // import Error404Modern from "./pages/error/404-modern";
// // import Error504Modern from "./pages/error/504-modern";
// // import Error504Classic from "./pages/error/504-classic";

// // import Faq from "./pages/others/Faq";
// // import Terms from "./pages/others/Terms";

// import Login from "./pages/auth/Login";
// // import Register from "./pages/auth/Register";
// // import ForgotPassword from "./pages/auth/ForgotPassword";
// // import Success from "./pages/auth/Success";
// // import InvoicePrint from "./pages/pre-built/invoice/InvoicePrint";
// import { GlobalProvider } from "./context/Provider";

// const App = () => {
//   return (
//     <GlobalProvider>
//       <Router>
//         <Routes>
//           {/* Auth Pages */}
//           {/* <Route exact path={`${process.env.PUBLIC_URL}/auth-success`} component={Success}></Route>
//           <Route exact path={`${process.env.PUBLIC_URL}/auth-reset`} component={ForgotPassword}></Route>
//           <Route exact path={`${process.env.PUBLIC_URL}/auth-register`} component={Register}></Route> */}
//           <Route path={`${process.env.PUBLIC_URL}/auth-login`} element={<Login />}></Route>

//           {/* Print Pages */}
//           {/* <Route exact path={`${process.env.PUBLIC_URL}/invoice-print/:id`} component={InvoicePrint}></Route> */}

//           {/* Helper pages */}
//           {/* <Route exact path={`${process.env.PUBLIC_URL}/auths/terms`} component={Terms}></Route>
//           <Route exact path={`${process.env.PUBLIC_URL}/auths/faq`} component={Faq}></Route>

//           <Route exact path={`${process.env.PUBLIC_URL}/invoice-print`} component={InvoicePrint}></Route> */}

//           {/*Error Pages*/}
//           {/* <Route exact path={`${process.env.PUBLIC_URL}/errors/404-classic`} component={Error404Classic}></Route>
//           <Route exact path={`${process.env.PUBLIC_URL}/errors/504-modern`} component={Error504Modern}></Route>
//           <Route exact path={`${process.env.PUBLIC_URL}/errors/404-modern`} component={Error404Modern}></Route>
//           <Route exact path={`${process.env.PUBLIC_URL}/errors/504-classic`} component={Error504Classic}></Route> */}

//           {/*Main Routes*/}
//           {/* <PrivateRoute exact path="" component={Layout}></PrivateRoute>
//           <Route component={RedirectAs404}></Route> */}
//         </Routes>
//       </Router>
//     </GlobalProvider>
    
//   );
// };
// export default App;
